import script from "./CryptoIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./CryptoIndex.vue?vue&type=script&setup=true&lang=ts"

import "./CryptoIndex.vue?vue&type=style&index=0&id=27977fa3&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27977fa3"]])

export default __exports__